import { OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NetPromoterScoreModalService } from '@core/components/net-promoter-score-modal/net-promoter-score-modal.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var NetPromoterScoreModalComponent = /** @class */ (function () {
    function NetPromoterScoreModalComponent(netPromoterScoreModalService, fuseTranslationLoaderService) {
        this.netPromoterScoreModalService = netPromoterScoreModalService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.stepIndex = 1;
        this.step = 'score-step';
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.netPromoterScoreForm = new FormGroup({
            score: new FormControl(-1),
            comment: new FormControl(null)
        });
    }
    NetPromoterScoreModalComponent.prototype.ngOnInit = function () {
    };
    NetPromoterScoreModalComponent.prototype.nextStep = function (event) {
        if (event.nextStep === 'comment-step') {
            this.step = event.nextStep;
            this.netPromoterScoreForm.get('score').setValue(event.score);
            this.stepIndex = 2;
        }
        if (event.nextStep === 'final-step') {
            this.step = event.nextStep;
            this.netPromoterScoreForm.get('comment').setValue(event.comment);
            this.stepIndex = 3;
            this.netPromoterScoreModalService.saveNPS(this.netPromoterScoreForm.get('score').value, this.netPromoterScoreForm.get('comment').value);
        }
        if (event.nextStep === 'close') {
            this.netPromoterScoreModalService.close();
        }
    };
    NetPromoterScoreModalComponent.prototype.previousStep = function () {
        this.step = 'score-step';
        this.stepIndex = 1;
    };
    return NetPromoterScoreModalComponent;
}());
export { NetPromoterScoreModalComponent };
